import React, { createContext, useContext, useState } from 'react';

export const FlowContext = createContext();

export const FlowProvider = ({ children }) => {
  const [probableFlow, setProbableFlow] = useState(0);

  return (
    <FlowContext.Provider value={{ probableFlow, setProbableFlow }}>
      {children}
    </FlowContext.Provider>
  );
};

export const useFlow = () => useContext(FlowContext);
